"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4839],{

/***/ 15738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BreadCrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Breadcrumbs/Breadcrumbs.js + 2 modules
var Breadcrumbs = __webpack_require__(7885);
// EXTERNAL MODULE: ./components/shopFeatures/wizard/constants.ts
var constants = __webpack_require__(45053);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(90387);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
;// CONCATENATED MODULE: ./reusable/icons/BreadCrumbsIcon.tsx

var SvgComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        width: "4",
        height: "8",
        viewBox: "0 0 4 8",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M3.5 7L0.5 4L3.5 1",
            stroke: "#D5D5D5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
};
/* harmony default export */ var BreadCrumbsIcon = (SvgComponent);

;// CONCATENATED MODULE: ./common/BreadCrumbsData.tsx
var BreadCrumbsData = {
    PrivacyPolicy: {
        links: [
            {
                title: "מדיניות הפרטיות",
                link: "/privacy-policy"
            }, 
        ]
    },
    TermsOfUse: {
        links: [
            {
                title: "תנאי שימוש",
                link: "/terms-of-use"
            }, 
        ]
    },
    Accessibility: {
        links: [
            {
                title: "הצהרת נגישות",
                link: "/accessibility"
            }, 
        ]
    },
    SiteMap: {
        links: [
            {
                title: "מפת אתר",
                link: "/sitemap"
            }
        ]
    },
    Recall: {
        links: [
            {
                title: "קריאות חוזרות",
                link: "/recall"
            }, 
        ]
    },
    Warranty: {
        links: [
            {
                title: "כתב אחריות",
                link: "/warranty"
            }, 
        ]
    },
    ServiceInstructions: {
        links: [
            {
                title: "הוראות שירות",
                link: "/service-instructions"
            }, 
        ]
    },
    WarrantyExtension: {
        links: [
            {
                title: "בדיקת תכולת הארכת אחריות",
                link: "/warranty-extension"
            }
        ]
    },
    SparePriceList: {
        links: [
            {
                title: "מחירון מוצרי תעבורה",
                link: "/spare-price-list"
            }, 
        ]
    },
    ColorCode: {
        links: [
            {
                title: "קוד צבע",
                link: "/color-code"
            }, 
        ]
    },
    Hamesayat: {
        links: [
            {
                title: "המסייעת",
                link: "/hamesayat"
            }, 
        ]
    },
    VideoTutorials: {
        links: [
            {
                title: "סרטוני הדרכה ותפעול",
                link: "/video-tutorials"
            }, 
        ]
    },
    ServicesCenters: {
        links: [
            {
                title: "מרכזי שירות",
                link: "/services-centers"
            }, 
        ]
    },
    ShowRooms: {
        links: [
            {
                title: "אולמות תצוגה",
                link: "/show-rooms"
            }, 
        ]
    },
    CarList: {
        links: [
            {
                title: "מחירון מכוניות",
                link: "/car-list"
            }, 
        ]
    },
    Insurance: {
        links: [
            {
                title: "ביטוח",
                link: "/insurance"
            }, 
        ]
    },
    CarFleets: {
        links: [
            {
                title: "ציי רכב",
                link: "/car-fleets"
            }, 
        ]
    },
    ContactUs: {
        links: [
            {
                title: "צרו קשר",
                link: "/contact-us"
            }, 
        ]
    },
    ServicePlans: {
        links: [
            {
                title: "תוכנית טיפול",
                link: "/service-plans"
            }, 
        ]
    }
};


// EXTERNAL MODULE: ./common/bit/NextLink.tsx
var NextLink = __webpack_require__(60687);
// EXTERNAL MODULE: ./common/bit/utils/slugify.ts
var slugify = __webpack_require__(38730);
;// CONCATENATED MODULE: ./common/BreadCrumbs.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        ";\n  ",
        ";\n\n  ",
        " {\n  }\n  ",
        " {\n    position: absolute;\n\n    ",
        ";\n    ",
        ";\n    ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  max-width: 1400px;\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n    display: flex;\n    justify-content: flex-start;\n    padding-right: 20px;\n  }\n\n  ",
        " {\n    ",
        ";\n    ",
        ";\n  }\n  svg {\n    margin-top: 2px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  font-size: 10px;\n  font-weight: 300;\n  letter-spacing: normal;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}









var SINGLE_SERVICE = "singleService";
var CONFIGURATOR = "configurator";
var StyledInnerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledInnerWrapper",
    componentId: "sc-e82e91a2-0"
})(_templateObject(), function(p) {
    return p.$page === SINGLE_SERVICE && "top: -20px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 25px";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "right: 50px;";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "top: -10px";
}, function(p) {
    return p.$page === SINGLE_SERVICE && "right: 0px";
});
var StyledWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    displayName: "BreadCrumbs__StyledWrapper",
    componentId: "sc-e82e91a2-1"
})(_templateObject1(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$page) !== CONFIGURATOR && "width: 100%;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.$page === CONFIGURATOR && "margin-top: -50px";
}, function(p) {
    return p.$page === CONFIGURATOR && (p === null || p === void 0 ? void 0 : p.$pathname) !== constants/* STEPS_EN.summary */.Ws.summary && "margin-right: 50px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return p.$page !== CONFIGURATOR && "padding-right: 15px;";
}, function(p) {
    return p.$pathname === constants/* STEPS_EN.color */.Ws.color && "padding-right: 16px";
});
var StyledLink = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* default */.Z).withConfig({
    displayName: "BreadCrumbs__StyledLink",
    componentId: "sc-e82e91a2-2"
})(_templateObject2(), function(p) {
    return p.theme.colors.disable;
});
var BreadCrumbsWrapper = function(param) {
    var name = param.name, modelName = param.modelName, id = param.id, page = param.page, pathname = param.pathname;
    var router = (0,client_router.useRouter)();
    var carLinkUrl = function() {
        var carLink = "/model/[modelId]/[modelSlug]".replace("[modelId]", id.toString()).replace("[modelSlug]", (0,slugify/* default */.Z)(modelName));
        return carLink;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledWrapper, {
        $page: page,
        $pathname: pathname,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledInnerWrapper, {
            $page: page,
            children: [
                BreadCrumbsData[name] && !modelName && !id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        BreadCrumbsData[name].links.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                                color: "inherit",
                                href: item.link,
                                "aria-current": index === BreadCrumbsData[name].links.length - 1 && page !== SINGLE_SERVICE ? "page" : "step",
                                children: item.title
                            }, index);
                        }),
                        page === SINGLE_SERVICE && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: router.asPath,
                            "aria-current": "page",
                            children: router.query.serviceCenterSlug.toString().replace(/-/g, " ")
                        })
                    ]
                }),
                modelName && id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Breadcrumbs/* default */.Z, {
                    separator: /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadCrumbsIcon, {}),
                    "aria-label": "מיקומך בדפי האתר",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/",
                            children: "ראשי"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            color: "inherit",
                            href: "/models",
                            children: "לכל הדגמים"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: carLinkUrl(),
                            "aria-current": page !== CONFIGURATOR ? "page" : "step",
                            children: modelName
                        }),
                        page && page === CONFIGURATOR && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLink, {
                            href: router.asPath,
                            "aria-current": "page",
                            children: "התאמה אישית ורכישה"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BreadCrumbs = (BreadCrumbsWrapper);


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70655);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73192);
/* harmony import */ var focus_formik_error__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledForm = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_3__.Form).withConfig({
    displayName: "FormikForm__StyledForm",
    componentId: "sc-1cd63cac-0"
})(_templateObject(), function(p) {
    return p.theme.breakpoints.down("sm");
});
function FormikForm(param) {
    var validationSchema = param.validationSchema, initialValues = param.initialValues, render = param.render, onSubmit = param.onSubmit, innerRef = param.innerRef;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(formik__WEBPACK_IMPORTED_MODULE_3__.Formik, {
        innerRef: innerRef,
        initialValues: initialValues,
        validationSchema: validationSchema,
        validateOnBlur: true,
        validateOnChange: true,
        onSubmit: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(values, actions) {
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            actions.setSubmitting(true);
                            return [
                                4,
                                onSubmit(values, actions)
                            ];
                        case 1:
                            _state.sent();
                            actions.setSubmitting(false);
                            return [
                                2
                            ];
                    }
                });
            });
            return function(values, actions) {
                return _ref.apply(this, arguments);
            };
        }(),
        children: function(formik) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledForm, {
                noValidate: true,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(focus_formik_error__WEBPACK_IMPORTED_MODULE_2__.ConnectedFocusError, {}),
                    render(formik)
                ]
            });
        }
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (FormikForm);


/***/ }),

/***/ 11852:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82175);
/* harmony import */ var formik_material_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24065);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    ",
        "\n    width: 100%;\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    .MuiFormHelperText-root.Mui-error {\n      ",
        "\n    }\n    input {\n      color: ",
        ';\n      font-family: "OENaPro";\n      font-style: normal;\n      font-weight: 400;\n      font-size: 16px;\n      line-height: 140%;\n      ',
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var Styled = {
    Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_2__.Field).withConfig({
        displayName: "FormikInput__Field",
        componentId: "sc-ca467ef3-0"
    })(_templateObject(), function(p) {
        return (p === null || p === void 0 ? void 0 : p.$hideLabel) && "label { display: none; }";
    }, function(p) {
        return p.$center ? "text-align: center;" : "";
    }, function(p) {
        return p.theme.colors.black;
    }, function(p) {
        return p.$center ? "text-align: center;" : "";
    })
};
var FormikInput = function(_param) {
    var name = _param.name, label = _param.label, _type = _param.type, type = _type === void 0 ? "text" : _type, _required = _param.required, required = _required === void 0 ? false : _required, placeholder = _param.placeholder, maxLength = _param.maxLength, numeric = _param.numeric, InputProps = _param.InputProps, centerField = _param.centerField, autoFocus = _param.autoFocus, className = _param.className, hideLabel = _param.hideLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "name",
        "label",
        "type",
        "required",
        "placeholder",
        "maxLength",
        "numeric",
        "InputProps",
        "centerField",
        "autoFocus",
        "className",
        "hideLabel"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Styled.Field, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        $center: centerField,
        $hideLabel: hideLabel,
        label: label,
        component: formik_material_ui__WEBPACK_IMPORTED_MODULE_3__/* .TextField */ .nv,
        id: name,
        name: name,
        type: type,
        required: required,
        helperText: " ",
        placeholder: placeholder,
        inputProps: {
            maxLength: maxLength,
            inputMode: numeric && "numeric",
            pattern: numeric && "[0-9]*"
        },
        InputProps: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, InputProps),
        autoFocus: autoFocus,
        variant: "outlined",
        className: className
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (FormikInput);


/***/ }),

/***/ 46363:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ required; },
/* harmony export */   "Cr": function() { return /* binding */ schemaCommon; },
/* harmony export */   "Sz": function() { return /* binding */ regex; }
/* harmony export */ });
/* unused harmony exports max, invalid */
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(74231);

var max = {
    fullname: [
        50,
        "ניתן להזין עד 50 תווים"
    ]
};
var required = {
    default: "שדה זה הינו שדה חובה",
    firstName: "יש להזין שם פרטי",
    lastName: "יש להזין שם משפחה",
    phoneNumber: "יש להזין מספר טלפון",
    licenseNumber: "יש להזין לוחית רישוי",
    licenceOrChassis: "נא הכנס מספר רישוי או שילדה",
    modelId: "בחר דגם",
    area: "בחר איזור",
    skuOrName: "נא הכנס טקסט חופשי או מספר פריט"
};
var regex = {
    numbersAndLetters: /^[a-zA-Zא-תא-ת0-9 ]+$/,
    numbers: /^[0-9]*$/,
    singleName: /^[a-zA-Zא-ת ״\-,.׳]+$/,
    fullName: /([a-zA-Zא-ת'"\\.-/,].+\s).+/,
    name: /^[A-Za-z\u00C0-\u017F\u0590-\u05fe ,.'-]+$/,
    phoneNumber: /^05\d([-]{0,1})\d{7}$/,
    licenseNumber: /^([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})$/,
    licenceOrChassis: /^(([0-9]{2}-[0-9]{3}-[0-9]{2}|[0-9]{3}-[0-9]{2}-[0-9]{3}|[0-9]{7,8})|([A-Z]{2}[A-Z0-9]{12}))$/
};
var invalid = {
    numbers: "יש להזין ספרות בלבד",
    numbersShort: "ספרות בלבד",
    numbersAndLetters: "ספרות ואותיות",
    fullName: "שם מלא לא תקין",
    name: "יש להזין אותיות בעברית / אנגלית בלבד",
    email: "כתובת המייל אינה תקינה",
    phoneNumber: "מספר הטלפון אינו תקין",
    licenseNumber: "לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות שמורכב מספרות בלבד",
    licenceOrChassis: "מספר רישוי או שילדה לא תקין"
};
var schemaCommon = {
    phoneNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.phoneNumber, "עד 10 ספרות, ללא מקף").length(10, "עד 10 ספרות, ללא מקף").required("עד 10 ספרות, ללא מקף").max(10, "עד 10 ספרות, ללא מקף"),
    firstName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    lastName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.singleName, "רק אותיות בעברית או באנגלית בבקשה").min(2, "יש להזין לפחות שתי אותיות תחת השם").max(50, "יש להזין עד 50 תווים בלבד").required(required.default),
    fullName: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.fullName, "שם מלא בבקשה :)").max(100, "יש להזין עד 100 תווים בלבד").required(required.default),
    email: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().email("כתובת המייל לא תקינה").required(required.default),
    city: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    street: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_(),
    apartmentNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    floorNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    entranceNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbersAndLetters, invalid.numbersAndLetters),
    comments: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(200, "ניתן להזין עד 200 תווים"),
    termsOfUseCheckbox: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "יש לאשר את תנאי השימוש"),
    onlyNumbers: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().matches(regex.numbers, invalid.numbersShort),
    organization: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    organizationTitle: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().max(100, "יש להזין עד 100 תווים בלבד"),
    checkboxRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().required("").oneOf([
        true
    ], "שדה חובה"),
    checkboxNotRequired: yup__WEBPACK_IMPORTED_MODULE_0__/* .boolean */ .O7().defined(),
    licenseNumber: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("לוחית רישוי אינה תקינה, נא להזין מספר בעל 7-8 ספרות ברצף וללא מקף").matches(regex.licenseNumber, invalid.licenseNumber),
    chassis: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required("מספר שילדה אינו תקין"),
    catalog: yup__WEBPACK_IMPORTED_MODULE_0__/* .string */ .Z_().required(required.default)
};


/***/ }),

/***/ 77498:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64436);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85161);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22318);
/* harmony import */ var common_bit_form_FormikInput__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11852);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82175);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 100%;\n    .MuiFormHelperText-root {\n      font-size: 12px;\n    }\n    .MuiFormHelperText-root.Mui-error {\n      ",
        "\n    }\n    input {\n      ",
        "\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    margin-top: ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    display: flex;\n    align-items: center;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    transform: none !important;\n    font-size: 16px;\n    color: ",
        ";\n    font-weight: 400;\n    ",
        "\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    text-align: start;\n    font-size: 15px;\n    margin-top: -23px;\n    color: ",
        ";\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    width: 24px;\n    height: 24px;\n  "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}





var Styled = {
    Field: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(formik__WEBPACK_IMPORTED_MODULE_3__.Field).withConfig({
        displayName: "FormInput__Field",
        componentId: "sc-6b978e1d-0"
    })(_templateObject(), function(p) {
        return p.$center ? "text-align: center;" : "";
    }, function(p) {
        return p.$center ? "text-align: center;" : "";
    }),
    FormControl: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z).withConfig({
        displayName: "FormInput__FormControl",
        componentId: "sc-6b978e1d-1"
    })(_templateObject1()),
    FieldWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
        displayName: "FormInput__FieldWrapper",
        componentId: "sc-6b978e1d-2"
    })(_templateObject2(), function(p) {
        if ((p === null || p === void 0 ? void 0 : p.$marginTop) === 0) return "0px";
        if (p === null || p === void 0 ? void 0 : p.$marginTop) return p.$marginTop + "px";
        return "22px";
    }),
    LabelWrapper: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
        displayName: "FormInput__LabelWrapper",
        componentId: "sc-6b978e1d-3"
    })(_templateObject3()),
    InputLabel: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
        displayName: "FormInput__InputLabel",
        componentId: "sc-6b978e1d-4"
    })(_templateObject4(), function(p) {
        return p.theme.colors.darkGrey;
    }, function(p) {
        return p.$center ? "width: 100%; right: none; text-align: center;" : "";
    }),
    BottomText: (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).attrs({
        variant: "body1"
    }).withConfig({
        displayName: "FormInput__BottomText",
        componentId: "sc-6b978e1d-5"
    })(_templateObject5(), function(p) {
        return p.theme.colors.marbleGrey;
    }),
    SvgImg: styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].img.withConfig */ .ZP.img.withConfig({
        displayName: "FormInput__SvgImg",
        componentId: "sc-6b978e1d-6"
    })(_templateObject6())
};
var FormInput = function(_param) {
    var name = _param.name, label = _param.label, _type = _param.type, type = _type === void 0 ? "text" : _type, _required = _param.required, required = _required === void 0 ? false : _required, placeholder = _param.placeholder, maxLength = _param.maxLength, numericKeyBoard = _param.numericKeyBoard, InputProps = _param.InputProps, // bottomText,
    centerField = _param.centerField, autoFocus = _param.autoFocus, className = _param.className, hideLabel = _param.hideLabel, marginTop = _param.marginTop, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "name",
        "label",
        "type",
        "required",
        "placeholder",
        "maxLength",
        "numericKeyBoard",
        "InputProps",
        "centerField",
        "autoFocus",
        "className",
        "hideLabel",
        "marginTop"
    ]);
    // const [field, { error, touched }] = useField(name)
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,formik__WEBPACK_IMPORTED_MODULE_3__.useField)(name), 1), field = ref[0];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Styled.FieldWrapper, {
            $marginTop: marginTop,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(common_bit_form_FormikInput__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                name: name,
                label: label,
                type: numericKeyBoard ? "tel" : type,
                required: required,
                placeholder: placeholder,
                maxLength: maxLength,
                numeric: numericKeyBoard,
                centerField: centerField,
                InputProps: InputProps,
                autoFocus: autoFocus,
                className: className,
                hideLabel: hideLabel
            }, field, props))
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormInput);


/***/ }),

/***/ 27047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57833);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "FormSuccessState__StyledWrapper",
    componentId: "sc-91a45e38-0"
})(_templateObject());
var FormSuccessState = function(param) {
    var _title = param.title, title = _title === void 0 ? "תודה שפנית אלינו!" : _title, _subtitle = param.subtitle, subtitle = _subtitle === void 0 ? "נשמח ליצור איתך קשר בקרוב" : _subtitle;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        var ref1;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
            block: "nearest"
        });
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .StyledSvgIcon */ .vV, {
                src: "/icons/sucssesIcon.svg",
                w: 76,
                h: 76
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyCenter */ .kc, {
                variant: "h2",
                role: "alert",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_3__/* .TypographyCenter */ .kc, {
                variant: "body1",
                style: {
                    whiteSpace: "pre-line"
                },
                children: subtitle
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormSuccessState);


/***/ }),

/***/ 2423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22038);






var SvgComponent = function(_param) {
    var _color = _param.color, color = _color === void 0 ? theme_colors__WEBPACK_IMPORTED_MODULE_2__/* ["default"].disable */ .Z.disable : _color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "color"
    ]);
    var w = 35;
    var h = 35;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 ".concat(w, " ").concat(h),
        width: w,
        height: h,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                width: "35",
                height: "35",
                fill: "#f5f5f50"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.25 11L10.75 24.5",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M24.25 24.25L10.75 10.75",
                stroke: color,
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgComponent);


/***/ }),

/***/ 66395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52663);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22318);
/* harmony import */ var reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2423);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57833);
/* harmony import */ var theme_colors__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22038);
/* harmony import */ var theme_shared__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6089);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .MuiDialog-paper {\n    width: ",
        ";\n    border-radius: 8px;\n    background-color: ",
        ";\n    padding: 20px;\n    padding-left: ",
        ";\n    padding-right: ",
        ";\n    box-shadow: ",
        ";\n    max-width: ",
        " !important;\n  }\n  /* mobile size: */\n  ",
        " {\n    .MuiDialog-paper {\n      ",
        "\n    }\n\n    .MuiDialog-container {\n      height: 100%;\n      max-height: 100vh;\n      max-width: 560px !important;\n      margin: auto;\n    }\n    .MuiDialog-paperScrollBody {\n      margin: auto;\n    }\n  }\n  /* desktop size: */\n  ",
        " {\n    .MuiDialog-paper {\n      max-height: none;\n      overflow: initial;\n    }\n  }\n  ",
        " {\n    .mobile-margin {\n      margin: 34px 0;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  form {\n    height: 100%;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  z-index: 2;\n  ",
        " {\n    padding: 0px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  font-size: 24px;\n  font-weight: 400;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  max-width: 400px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  height: 100%;\n  display: ",
        ";\n  align-items: center;\n  flex-direction: column;\n  justify-content: center;\n  gap: 10px;\n  /* if children */\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var StyledDialog = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z).withConfig({
    displayName: "ClassicPopUp__StyledDialog",
    componentId: "sc-9c187a67-0"
})(_templateObject(), function(p) {
    return (p === null || p === void 0 ? void 0 : p.$hasError) ? "560px" : "calc(100% - 40px)";
}, function(p) {
    return p.theme.colors.white;
}, function(p) {
    return p.$padding ? p.$padding : "20px";
}, function(p) {
    return p.$padding ? p.$padding : "20px";
}, function(p) {
    return p.theme.boxShadows.cardShadow;
}, function(p) {
    return p.$narrow ? "350px" : "650px";
}, function(p) {
    return p.theme.breakpoints.down("sm");
}, function(p) {
    return (p === null || p === void 0 ? void 0 : p.$hasError) && "width: 316px;";
}, function(p) {
    return p.theme.breakpoints.up("md");
}, function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClassicPopUp__StyledWrapper",
    componentId: "sc-9c187a67-1"
})(_templateObject1());
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z).withConfig({
    displayName: "ClassicPopUp__StyledIconButton",
    componentId: "sc-9c187a67-2"
})(_templateObject2(), function(p) {
    return p.theme.breakpoints.down("sm");
});
var StyledTitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "h2"
}).withConfig({
    displayName: "ClassicPopUp__StyledTitle",
    componentId: "sc-9c187a67-3"
})(_templateObject3());
var StyledSubtitle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_material_ui_core__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z).attrs({
    variant: "body1"
}).withConfig({
    displayName: "ClassicPopUp__StyledSubtitle",
    componentId: "sc-9c187a67-4"
})(_templateObject4());
var StyledPopUpTop = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    displayName: "ClassicPopUp__StyledPopUpTop",
    componentId: "sc-9c187a67-5"
})(_templateObject5(), function(p) {
    return p.$hasError ? "none" : "flex";
}, function(p) {
    return p.$hasChildren && "margin-bottom: 20px;";
});
var ClassicPopUp = function(param) {
    var open = param.open, setOpen = param.setOpen, onClose = param.onClose, children = param.children, icon = param.icon, title = param.title, text = param.text, hasError = param.hasError, className = param.className, _backgroundColor = param.backgroundColor, backgroundColor = _backgroundColor === void 0 ? true : _backgroundColor, _withDivider = param.withDivider, withDivider = _withDivider === void 0 ? false : _withDivider, _narrow = param.narrow, narrow = _narrow === void 0 ? false : _narrow, dialogClass = param.dialogClass, padding = param.padding, arialabelledby = param.arialabelledby, invertCloseIcon = param.invertCloseIcon;
    var handleClose = function() {
        if (setOpen) {
            setOpen(false);
        }
        if (onClose) {
            onClose();
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledDialog, {
        open: open,
        onClose: handleClose,
        scroll: "body",
        className: className,
        $backgroundColor: backgroundColor,
        $narrow: narrow,
        classes: {
            paper: dialogClass
        },
        "aria-modal": true,
        tabIndex: -1,
        "aria-labelledby": arialabelledby ? arialabelledby : title,
        $hasError: hasError,
        $padding: padding,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
                onClick: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(reusable_icons_CloseIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    width: 35,
                    height: 35,
                    "aria-label": "close window",
                    color: invertCloseIcon ? "white" : undefined
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledWrapper, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledPopUpTop, {
                        $hasError: hasError,
                        $hasChildren: children !== undefined || withDivider,
                        children: [
                            icon && icon,
                            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTitle, {
                                children: title
                            }),
                            text && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledSubtitle, {
                                children: text
                            })
                        ]
                    }),
                    withDivider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(theme_shared__WEBPACK_IMPORTED_MODULE_4__/* .StyledDividerH */ .aV, {
                        $color: theme_colors__WEBPACK_IMPORTED_MODULE_3__/* ["default"].darkGrey */ .Z.darkGrey,
                        $width: 0.5,
                        $radius: 3,
                        $mb: "20px"
                    }),
                    children
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ClassicPopUp);


/***/ })

}]);